import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import Table from '../../../../Common/Table/Table';
import './SignTradeOrders.scss';
import { signTradeOrdersCols } from './columns';
import { hPoolSignTransactionContext } from '../CreateHPoolSignTransaction';
import { useAssetsSignatures } from '../../../../../hooks/useAssetsSignatures';

export default function SignTradeOrders({ tradeOrders = [], ...rest }) {
  const { setSelectedToken } = useContext(hPoolSignTransactionContext);
  const state = {
    setSelectedToken,
  };

  const [, setAssetSigantures, , , loading] = useAssetsSignatures('BuyOrderRatio');
  const signInfo = {
    signMethod: setAssetSigantures,
    loading,
  };
  return (
    <div className="sign-trade-wrapper">
      <Table dataSourse={tradeOrders} hideHeader cols={signTradeOrdersCols(signInfo)} {...rest} />
    </div>
  );
}

SignTradeOrders.propTypes = {
  tradeOrders: PropTypes.array.isRequired,
};
